import { Divider, Row, Tabs } from '@bancobarigui/barihaus';

import { UserInfoForm } from '@/components/UserInfoForm';
import { RoleTransfer } from '@/components/RoleTransfer';

import { RoleModuleType } from '@/shared/enums/RoleModuleType';

export function ProviderUserForm() {
  return (
    <>
      <UserInfoForm />

      <Divider>Configurações</Divider>

      <Row>Defina os items que serão associados ao usuário.</Row>

      <Tabs
        items={[
          {
            key: '1',
            label: 'Perfil de Acesso',
            children: <RoleTransfer module={RoleModuleType.provider} />,
          },
        ]}
      />
    </>
  );
}
